module.exports = __webpack_public_path__ + "static/media/WordsOfRenewalPuzzleBook.c9712287.jpg";